import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Accueil from "./pages/Accueil";
import Pneumatique from "./pages/Pneumatique";
import Parallelisme from "./pages/Parallelisme";
import Climatisation from "./pages/Climatisation";
import Mecanique from "./pages/Mecanique";
import Catalogue from "./pages/Catalogue";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPromotions from "./pages/admin/AdminPromotions";
import AdminTarifs from "./pages/admin/AdminTarifs";
import AdminHoraires from "./pages/admin/AdminHoraires";
import AdminCatalogue from "./pages/admin/AdminCatalogue";
import AdminPhotos from "./pages/admin/AdminPhotos";
import AdminDemandes from "./pages/admin/AdminDemandes";
import AdminMotDePasse from "./pages/admin/AdminMotDePasse";

function Prive({ children }) {
  const { user, chargement } = useAuth();
  if (chargement) {
    return (
      <div className="min-h-screen bg-brand-light flex items-center justify-center">
        <p className="font-heading font-semibold uppercase text-2xl text-brand-dark">Chargement…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Accueil />} />
            <Route path="/pneumatique" element={<Pneumatique />} />
            <Route path="/parallelisme" element={<Parallelisme />} />
            <Route path="/climatisation" element={<Climatisation />} />
            <Route path="/mecanique" element={<Mecanique />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route element={<Prive><AdminLayout /></Prive>}>
            <Route path="/admin/tableau-de-bord" element={<AdminDashboard />} />
            <Route path="/admin/promotions" element={<AdminPromotions />} />
            <Route path="/admin/tarifs" element={<AdminTarifs />} />
            <Route path="/admin/horaires" element={<AdminHoraires />} />
            <Route path="/admin/catalogue" element={<AdminCatalogue />} />
            <Route path="/admin/photos" element={<AdminPhotos />} />
            <Route path="/admin/demandes" element={<AdminDemandes />} />
            <Route path="/admin/mot-de-passe" element={<AdminMotDePasse />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
